/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const LessThanOrEqualFilesize: core.serialization.ObjectSchema<
    serializers.LessThanOrEqualFilesize.Raw,
    Truvity.LessThanOrEqualFilesize
> = core.serialization.object({
    value: core.serialization.number(),
});

export declare namespace LessThanOrEqualFilesize {
    export interface Raw {
        value: number;
    }
}
